(async() => {
  const variantId = window?.AVADA_SC?.product?.variants?.[0]?.id;

if (!variantId) return;

const bundleData = await getBundleProducts(variantId)

if (bundleData?.isBundleProduct) {
    const products = bundleData?.products;
    if (!products.length) return;

    const productMap = Object.fromEntries(
    products.map((p) => [p.title.trim(), p])
    );

    document
    .querySelectorAll("variant-radios fieldset, variant-selects fieldset")
    .forEach((fieldset) => {
      const legend = fieldset.querySelector("legend");
      if (!legend) return;
      
      const legendText = legend.textContent.trim();

      const product = products.find((p) =>
        legendText.includes(p.title)
      );

      if (!product) return;

      fieldset.dataset.productId = product.id;
      const marker = document.createElement("span");
      marker.style.display = "none";
      marker.dataset.trigger = product.id;

      fieldset.appendChild(marker);
    });
} else {
    console.log("NOT a bundle product")
}
})()

async function getBundleProducts(bundleVariantId) {
  const endpoint = `https://${Shopify.shop}/api/2024-07/graphql.json`;

  const query = `
    query ($id: ID!) {
      node(id: $id) {
        ... on ProductVariant {
          requiresComponents
          components(first: 50) {
            nodes {
              quantity
              productVariant {
                id
                title
                product {
                  id
                  title
                  handle
                }
              }
            }
          }
        }
      }
    }
  `;

  const response = await fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      query,
      variables: {
        id: `gid://shopify/ProductVariant/${bundleVariantId}`,
      },
    }),
  });

  const { data, errors } = await response.json();

  if (errors) {
    throw new Error(errors.map((e) => e.message).join("\n"));
  }

  const node = data?.node;

  return {
    isBundleProduct: Boolean(node?.requiresComponents),
    products:
      node?.components?.nodes?.map(({ quantity, productVariant }) => ({
        id: productVariant.product.id.replace("gid://shopify/Product/", ""),
        title: productVariant.product.title,
        handle: productVariant.product.handle,
        url: `/products/${productVariant.product.handle}`,
        quantity,
        selectedVariant: {
          id: productVariant.id.replace(
            "gid://shopify/ProductVariant/",
            ""
          ),
          title: productVariant.title,
        },
      })) ?? [],
  };
}
